import { useFormContext, type Path } from 'react-hook-form';
import { toast } from 'react-toastify';
import type {
  ClientDocumentWithPassportData,
  CreateClientFormData,
  PassportDataWithName,
} from '@/types/clientsApiTypes';
import { TableRow } from './components/TableRow';

interface DocumentTableProps {
  documents: ClientDocumentWithPassportData[];
  fieldPrefix: string;
  tableRowClassName?: string;
  passengerFullName: string;
  onUpdateDocuments?: (documents: PassportDataWithName, documentId: number | null) => void;
  onDeleteDocuments?: (documentId: number) => void;
}

export const DocumentTable = ({
  documents,
  fieldPrefix,
  tableRowClassName,
  passengerFullName,
  onUpdateDocuments = () => {},
  onDeleteDocuments = () => {},
}: DocumentTableProps) => {
  const { setValue } = useFormContext<CreateClientFormData>();

  const handleDeleteDocument = (id: number | null) => {
    if (!id) {
      toast.error('No document to delete');
      return;
    }
    onDeleteDocuments?.(id);
    const newDocuments = documents.filter((doc) => doc.id !== id);

    setValue(`${fieldPrefix}.documents` as Path<CreateClientFormData>, newDocuments);
  };

  return (
    <>
      <table className="min-w-full border-separate border-spacing-y-[16px]">
        <tbody>
          {documents.map((doc, idx) => (
            <TableRow
              key={`wrapper-${idx}`}
              document={doc}
              fieldPrefix={`${fieldPrefix}.documents.${idx}`}
              isLastRow={idx === documents.length - 1}
              onDeleteDocuments={() => handleDeleteDocument(doc.id)}
              tableRowClassName={tableRowClassName}
              passengerFullName={passengerFullName}
              onUpdateDocuments={(documents: PassportDataWithName) => onUpdateDocuments(documents, doc.id)}
            />
          ))}
        </tbody>
      </table>
    </>
  );
};
